import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Colors } from '@adsk/bim360-matrix-react-helpers/es/consts';

import './_StatusColorIndicator.scss';

import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';

/**
 * Renders a status indicator based on statusColor passed
 */
export default function StatusColorIndicator({ style, classNames, statusColor, ...rest }) {
  const classes = cx('StatusColorIndicator', `StatusColorIndicator__${statusColor}`, classNames);
  return <div {...rest} className={classes} style={style} />;
}

StatusColorIndicator.Colors = Colors;

StatusColorIndicator.propTypes = {
  /**
   * The color of the status.
   */
  statusColor: PropTypes.oneOf(objectValues(StatusColorIndicator.Colors)).isRequired,
  /**
   * Additional className.
   */
  classNames: PropTypes.string,
  /**
   * A custom style for the element of the component.
   */
  style: PropTypes.object
};
